import { Box, Button, Grid2, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Backbutton from './Backbutton'
import Styles from '../Config/Styles'
import ButtonBox from './Button'
import { useNavigate } from 'react-router-dom'
import { INFO } from '../Routes/constURL'
import { useDispatch, useSelector } from 'react-redux'
import { choosetype, roles } from '../Redux/Login/action'
import { getdraftOrders } from '../Redux/Mycart/action'

const ChooseType = ({ setComponent, setLoading, cart }) => {
  const { roleData } = useSelector((state) => state?.LoginData) || [];
  const { orders } = useSelector((state) => state?.CartData) || [];

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [selectedType, setSelectedType] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (roleData == null)
      dispatch(roles())
    if (!orders?.length) {
      const session = sessionStorage.getItem("session");
      dispatch(getdraftOrders({ session }));
    }
    const displayroles = roleData?.data?.map((item) => {
      return item.name !== "Administrator" && item
    }).filter(Boolean);
    setSelectedType(displayroles)
  }, [roleData, orders])


  const handleSelect = (index, id) => {
    setSelected({ index, id })
  };
  const handleback = () => {
    setComponent("verify")
  }

  const handleClick = async () => {
    setLoading(true)
    dispatch(choosetype({ role: selected.id }, setLoading, navigate, orders))

  }

  return (
    <Box sx={Styles.middleBoxStyle().box2}>
      {/* <Backbutton onClick={handleback} /> */}
      <Box sx={Styles.middleBoxStyle().innerbox}>

        {/* Title */}
        <Typography variant="h4" gutterBottom sx={Styles.middleBoxStyle().typo}>
          What type of user suits you?
        </Typography>

        {/* User Type Cards */}
        <Grid2 container spacing={2} sx={Styles.middleBoxStyle("","",cart).typegrid}>
          {selectedType?.map((item, index) =>
            <Grid2 item xs={12} sm={6} sx={Styles.middleBoxStyle().typeinnergrid}>
              <Paper
                elevation={index === selected?.index ? 8 : 1}
                onClick={() => handleSelect(index, item?.id)}
                sx={Styles.middleBoxStyle(selectedType).paper}
              >
                <Typography variant="h6" sx={Styles.middleBoxStyle().outerTypo}>{item.name} : <span style={Styles.middleBoxStyle().span}>
                  {item.description}
                </span></Typography>

              </Paper>
            </Grid2>
          )}
        </Grid2>

        {/* Submit Button */}
        <Box sx={Styles.middleBoxStyle().btnbox}>

          <ButtonBox text={"Submit"} disabled={selected === null} color={"black"} onClick={handleClick} />
        </Box>
      </Box>
    </Box>
  )
}

export default ChooseType